import { PureComponent } from "react";

import { type AddressEntity } from "commonComponents/entity/address/Address/Address.api.types";
import AddressDisplay from "commonComponents/entity/address/AddressDisplay";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

type CellType = AddressEntity | undefined;

class SingleLineAddressCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        const { cellValue } = this.props;

        if (!cellValue) {
            return null;
        }

        return <AddressDisplay address={cellValue} singleLineFormat />;
    }
}

export const columnSingleLineAddress: IClientGridColumn<CellType> = {
    columnType: GridColumnType.singleLineAddress,
    Cell: SingleLineAddressCell,
};
